var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('scene'+_vm.$store.getters.scene,{tag:"component",attrs:{"role":"screen"}})}
var staticRenderFns = []

export { render, staticRenderFns }